import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'react-jss';
import { DatePicker, Input, Select } from 'antd';
import { DeleteOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Controller } from 'react-hook-form';

import { useSelector } from 'react-redux';
import GetField from '../Components/GetField';
import styles from '../styles';
import { getGrandTotal } from './common-functions';

const AntSelect = GetField(Select);
const AntInput = GetField(Input);
const { Option } = Select;
const AntDatePicker = GetField(DatePicker);

const ItemForm = props => {
  const {
    classes,
    getValues,
    setValue,
    control,
    watch,
    itemItem,
    itemIndex,
    itemRemove,
    itemAppend,
  } = props;

  const unitIds = useSelector(state => state.unitIds);

  useEffect(() => {
    const quantity = getValues(`items[${itemIndex}].quantity`) || 0;
    const rate = getValues(`items[${itemIndex}].rate`) || 0;
    const gst = getValues(`items[${itemIndex}].gst`) || 0;

    const value = +(+quantity * +rate).toFixed(2) || 0;
    const gstValue = +((+value * +gst) / 100).toFixed(2);
    const total = +(+value + +gstValue || 0).toFixed(2);
    const singleTotal = +(total / (quantity || 1)).toFixed(2);

    setValue(`items[${itemIndex}].value`, value);
    setValue(`items[${itemIndex}].gstValue`, gstValue);
    setValue(`items[${itemIndex}].singleTotal`, singleTotal);
    setValue(`items[${itemIndex}].total`, total);
  }, [
    watch(`items[${itemIndex}].quantity`),
    watch(`items[${itemIndex}].rate`),
    watch(`items[${itemIndex}].gst`),
  ]);

  useEffect(() => {
    const fabricItems = getValues('fabrics');
    const accessoryItems = getValues('accessories');
    const items = getValues('items');
    const stylesItems = getValues('styles');
    setValue(
      'grandTotal',
      getGrandTotal(fabricItems, accessoryItems, items, stylesItems)
    );
  }, [watch(`items[${itemIndex}].total`)]);

  return (
    <tr>
      <td className={classes.inputTd}>
        <Controller
          name={`items[${itemIndex}].name`}
          control={control}
          defaultValue={itemItem.name}
          render={({ field }) => (
            <AntInput placeholder="Item" size="small" {...field} />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`items[${itemIndex}].shade`}
          control={control}
          defaultValue={itemItem.shade}
          render={({ field }) => (
            <AntInput placeholder="Shade" {...field} size="small" />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`items[${itemIndex}].size`}
          control={control}
          defaultValue={itemItem.size}
          render={({ field }) => (
            <AntInput placeholder="Size" {...field} size="small" />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`items[${itemIndex}].unitId`}
          control={control}
          defaultValue={itemItem.unitId}
          render={({ field }) => (
            <AntSelect placeholder="Select unit" {...field}>
              {unitIds.map(unit => (
                <Option key={unit.id} value={unit.id}>
                  {unit.unit}
                </Option>
              ))}
            </AntSelect>
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`items[${itemIndex}].quantity`}
          control={control}
          defaultValue={itemItem.quantity}
          render={({ field }) => (
            <AntInput
              placeholder="Quantity"
              {...field}
              type="number"
              min={0}
              size="small"
            />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`items[${itemIndex}].rate`}
          control={control}
          defaultValue={itemItem.rate}
          render={({ field }) => (
            <AntInput
              placeholder="Price"
              {...field}
              type="number"
              min={0}
              size="small"
            />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`items[${itemIndex}].value`}
          control={control}
          defaultValue={itemItem.value}
          render={({ field }) => (
            <AntInput
              placeholder="Amount"
              {...field}
              type="number"
              min={0}
              size="small"
              disabled
            />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`items[${itemIndex}].gst`}
          control={control}
          defaultValue={itemItem.gst}
          render={({ field }) => (
            <AntInput
              placeholder="GST (%)"
              {...field}
              type="number"
              min={0}
              size="small"
            />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`items[${itemIndex}].gstValue`}
          control={control}
          defaultValue={itemItem.gstValue}
          render={({ field }) => (
            <AntInput
              placeholder="GST Amount"
              {...field}
              type="number"
              min={0}
              size="small"
              disabled
            />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`items[${itemIndex}].singleTotal`}
          control={control}
          defaultValue={itemItem.singleTotal}
          render={({ field }) => (
            <AntInput
              placeholder="Total"
              {...field}
              type="number"
              min={0}
              size="small"
              disabled
            />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`items[${itemIndex}].total`}
          control={control}
          defaultValue={itemItem.total}
          render={({ field }) => (
            <AntInput
              placeholder="Total"
              {...field}
              type="number"
              min={0}
              size="small"
              disabled
            />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`items[${itemIndex}].hsn`}
          control={control}
          defaultValue={itemItem.hsn}
          render={({ field }) => <AntInput placeholder="HSN Code" {...field} />}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`items[${itemIndex}].deliveryDate`}
          control={control}
          render={({ field }) => (
            <AntDatePicker allowClear placeholder="Date" {...field} />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <DeleteOutlined
          onClick={() => {
            itemRemove(itemIndex);
          }}
        />
        &nbsp; &nbsp;
        <PlusCircleOutlined onClick={() => itemAppend({})} />
      </td>
    </tr>
  );
};

ItemForm.propTypes = {
  classes: PropTypes.object.isRequired,
  getValues: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  control: PropTypes.any.isRequired,
  watch: PropTypes.func.isRequired,
  itemAppend: PropTypes.func.isRequired,
  itemRemove: PropTypes.func.isRequired,
  itemItem: PropTypes.object.isRequired,
  itemIndex: PropTypes.number.isRequired,
};

export default withStyles(styles)(ItemForm);
